import { driver } from '@leagueplatform/masonry';
import type { MasonryEngineNodeRenderer } from '@leagueplatform/masonry-engine';
import {
  MASONRY_NAMESPACES,
  MASONRY_WIDGET_TYPES,
  MASONRY_ACTION_TYPES,
} from 'common/constants/masonry';
import { PrescriptionsRichText } from 'components/prescriptions/renderers/prescriptions-rich-text.renderer';
import {
  setPageActionHandler,
  PaginationLayout,
} from 'components/masonry-renderers/pagination-layout.renderer';
import { PrescriptionKeyValueDescription } from 'components/prescriptions/renderers/prescription-key-value-description.renderer';
import { PrescriptionDetailsSection } from 'components/prescriptions/renderers/prescription-details-section.renderer';
import { PageHeaderRenderer } from 'components/masonry-renderers/page-header.renderer';

export const initPrescriptionsRegistry = () => {
  // List Page
  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.PAGINATION_LAYOUT,
    MASONRY_NAMESPACES.PRESCRIPTIONS,
    PaginationLayout,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.SMALL_CARD,
    MASONRY_NAMESPACES.PRESCRIPTIONS,
    driver.nodeRendererRegistry.nodeRenderers.default.smallCard,
  );

  driver.actionController.registerHandler(
    'setPage',
    MASONRY_NAMESPACES.PRESCRIPTIONS,
    setPageActionHandler,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.RICH_TEXT,
    MASONRY_NAMESPACES.PRESCRIPTIONS,
    PrescriptionsRichText,
  );

  driver.actionController.registerHandler(
    MASONRY_ACTION_TYPES.DEEPLINK,
    MASONRY_NAMESPACES.PRESCRIPTIONS,
    () => {},
  );

  // Details Page
  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.SECTION_HEADER,
    MASONRY_NAMESPACES.PRESCRIPTION_DETAILS,
    PageHeaderRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.KEY_VALUE_HEADING_DESCRIPTION,
    MASONRY_NAMESPACES.PRESCRIPTION_DETAILS,
    PrescriptionKeyValueDescription,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.GRID_LAYOUT,
    MASONRY_NAMESPACES.PRESCRIPTION_DETAILS,
    // Cast needed: custom renderer properties differ from built-in gridLayout node type
    PrescriptionDetailsSection as unknown as MasonryEngineNodeRenderer<any>,
  );
};
